import { createReducer, on } from '@ngrx/store';
import { setCurrentPlatformData } from '../actions/platform.actions';
import { IPlatformDataState } from '../models/platform.model';

const initialState: IPlatformDataState = {
  platform: null,
};

export const platformDataReducer = createReducer(
  initialState,
  on(
    setCurrentPlatformData,
    (state: any, action): IPlatformDataState => ({
      ...state,
      platform: action.platform,
      error: null,
    }),
  ),
);
